import Team from './Team';

class Game {
    teams = [];

    initialTeam = 0;

    currentTeam = 0;

    constructor() {
        this.teams = [new Team(['Player 1']), new Team(['Player 2'])]
    }

    setInitialTeam(team) {
        if (team !== 0 && team !== 1) {
            return;
        }
        this.initialTeam = team;
        this.currentTeam = team;
    }

    totalPoints() {
        return this.teams.map(team => team.currentScore).reduce((acum, current) => {
            return acum + current;
        });
    }

    checkWinner() {
        const team1 = this.teams[0];
        const team2 = this.teams[1];
        if (team1.currentScore >= 11 && (team1.currentScore - team2.currentScore) >= 2) {
            this.addGame(team1);
        }
        if (team2.currentScore >= 11 && (team2.currentScore - team1.currentScore) >= 2) {
            this.addGame(team2);
        }
    }

    addGame(team) {
        team.currentGames++;
        this.resetPlay();
    }

    calculateNextTeam() {
        const totalPoints = this.totalPoints();

        if (totalPoints >= 11) {
            this.checkWinner();
        }

        if (totalPoints <= 20) {
            this.currentTeam = (totalPoints % 4 < 2) ?
                (this.initialTeam === 0 ? 0 : 1) :
                (this.initialTeam === 0 ? 1 : 0);
        }
        if (totalPoints > 20) {
            this.currentTeam = (totalPoints % 2 === 0) ?
                (this.initialTeam === 0 ? 0 : 1) :
                (this.initialTeam === 0 ? 1 : 0);
        }
    }

    addScore(team) {
        let currentTeam = team;
        if (!(currentTeam instanceof Object)) {
            currentTeam = this.teams[team];
        }
        currentTeam.currentScore++;
        this.calculateNextTeam();
    }

    subScore(team) {
        let currentTeam = team;
        if (!(currentTeam instanceof Object)) {
            currentTeam = this.teams[team];
        }
        if (currentTeam.currentScore <= 0) {
            return;
        }
        currentTeam.currentScore--;
        this.calculateNextTeam();
    }

    resetPlay() {
        this.teams.forEach(team => {
            team.currentScore = 0;
        });
        this.currentTeam = this.initialTeam;
    }

    resetGames() {
        this.resetPlay();
        this.teams.forEach(team => {
            team.currentGames = 0;
        })
    }
}

export default Game;